import axios from 'axios';
import React, { useEffect, useState } from 'react';
import './content-views.scss';
import { localize } from '/react4xp/mixins/helpers';
import EyeIcon from '/react4xp/mixins/ui/icons/eye-icon.svg';
import PartWrapper from '/react4xp/mixins/ui/part-wrapper';

type Props = {
    translations: Record<string, string>;
    contentId: string;
    path: string;
};

function ContentViews(props: Props) {
    const [isLoading, setIsLoading] = useState(true);
    const [views, setViews] = useState(0);

    useEffect(() => {
        axios
            .get('/_/service/isnareactcms/content-views', {
                params: {
                    contentId: props.contentId,
                    name: props.path,
                },
            })
            .then(({ data }) => {
                setViews(data.views);
            })
            .finally(() => {
                setIsLoading(false);
            });
    }, []);

    return (
        <div
            className="d-flex align-items-center gap-2 my-3"
            title={localize('views-counter', props.translations)}
        >
            <EyeIcon />
            {isLoading && '...'}
            {!isLoading && views}
        </div>
    );
}

export default (props) => (
    <PartWrapper {...props}>
        <ContentViews {...props} />
    </PartWrapper>
);
